export default {"src":"/_next/static/media/big_mobile_point_head.1a8e5af4.svg","height":45,"width":341,"blurWidth":0,"blurHeight":0};